const Colors = {
  Red: "#FF0000",
  Green: "#00D100",
};

export default Colors;
